module.exports = __webpack_public_path__ + "static/Image14@2x-1b6518c52f86bc392de349e34bae78ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image14@2x.jpg
// module id = 907
// module chunks = 227233210825294 244429959259914